<template>
    <div class="_main">
        <el-row :gutter="20">
            <el-col :span="8" v-for="item in dataInfo" :key="item.id">
                <div class="bg-color-light" @click="divClick(item.id)">{{ item.workName }}</div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import LibraryPost from '../../api/pServer/library';
export default {
    data() {
        return {
            dataInfo: []
        }
    },
    methods: {
        divClick(workId) {
            this.$router.push('/libraryTarget?workId=' + workId);
        }
    },
    created() {
        LibraryPost.queryAllWorkInfo().then((res) => {
            this.dataInfo = res.data.data;
        });
    },
}
</script>

<style scope>
._main {
    width: 100%;
    height: 100%;
    background-color: #fff;
}

.bg-color-light {
    height: 100px;
    background-color: #eff6ff;
    border-radius: 8px;
    margin: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 20px;
}
</style>